<!-- Library -->
<ng-container *ngFor="let pos of leftWindowPositions(); let rowIndex = index;">
    <svg:g [attr.transform]="'translate(' + pos.x + ', ' + pos.y + ')'">
            <path class="window-left"
            [style.animationDelay]="rowIndex * 0.01 + 's'"
                d="M132 192.39 L0.23 120.74 V134.50 L132 206.15 V192.39Z"
        [attr.fill]="pos.isLit ? 'var(--window-lit-bg-1)' : 'var(--window-dark-bg-1)'" />
        </svg:g>
</ng-container>


<ng-container *ngFor="let pos of rightWindowPositions(); let rowIndex = index;">
    <svg:g [attr.transform]="'translate(' + pos.x + ', ' + pos.y + ')'">
        <path class="window-right"
        [style.animationDelay]="rowIndex * 0.01 + 's'"
            d="M132 193 V206 L310 105 V92 L132 193 Z"
            [attr.fill]="pos.isLit ? 'var(--window-lit-bg-2)' : 'var(--window-dark-bg-1)'" />
    </svg:g>
</ng-container>